export default __webpack_public_path__ + "static/screenshot-editor-0442116fb24a9f4a4e2de0872797d707.png";